import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import styles from '../../css/MainPage.module.css';
import { useUser } from '../../Navbar/UserContext';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login: userLogin } = useUser();
  const { login: authLogin } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.post('https://techservicemarket-backend.onrender.com/api/users/login', {
        username,
        password,
      });

      const { token, id } = response.data;
      
      // Set in both contexts
      userLogin(token, { id, firstName: username, lastName: '' });
      authLogin(token, { id, firstName: username, lastName: '' }, 'user');
      
      // Store in localStorage
      localStorage.setItem('userId', id);
      localStorage.setItem('token', token);
      localStorage.setItem('lastPath', '/dashboard');
      
      navigate('/dashboard');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.mainPageBody}>
      <div className={styles.mainPageContainer}>
        <h2 className={styles.mainPageHeader}>Login</h2>
        <form onSubmit={handleLogin} className={styles.mainPageForm}>
          <div>
            <label className={styles.mainPageLabel}>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.mainPageInput}
            />
          </div>
          <div>
            <label className={styles.mainPageLabel}>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.mainPageInput}
            />
          </div>
          {errorMessage && <p className={styles.mainPageErrorMessage}>{errorMessage}</p>}
          <button type="submit" className={styles.loginButton} disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p style={{ marginTop: '20px' }}>
          Don't have an account yet?{' '}
          <Link to="/register" className={styles.registerLink}>Register here</Link>
        </p>
        <div className={styles.otherLoginOptions}>
          <p>Are you a recruiter? <Link to="/recruiter/login">Recruiter Login</Link></p>
          <p>Are you a university? <Link to="/university/login">University Login</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
